export const createEmptyObject = (n) => {
    const temp = []
    for (let i = 0; i < n; i++) {
        temp.push({ id: null })
    }
    return temp
}